module.exports = __webpack_public_path__ + "media/images/icon_ha-6e37a40a05f3b13e6c181aceeac2aec7.png";